<template>
  <LayoutDefault
    isShowFooter
    :dateCreated="formaterDate(formData?.DateCreated)"
    :datePublish="formaterDate(formData?.PublicationDate)"
    @storyChange="showStoryChangeModal"
    @saveForm="onSaveProduct"
    @publishForm="onTogglePublished"
    @removePublishForm="onTogglePublished"
    :publishDisabled="!canPublish"
    :isPublished="formData?.Published"
    :saveDisabled="!canSave || isSaving"
    :saveLoading="isSaving"
  >
    <FormConstructor
      @modal-switch="onModalSwitch"
      @openTagsModal="showTags"
      @openKeywordsModal="showKeywords"
      @goBack="closeEditor"
      @update-validity="updateFormValidity"
      @update-publish-status="updatePublishStatus"
      :save-btn-loader="isSaving"
      cascade-select
      story-change
      :formDataId="activityId"
      :policies="cutPolicies(policies, 'Products')"
    >
      <FormContentBlock
        v-if="formData.Images?.length !== 0"
        blok-type="Image"
        :images="formData?.Images"
        :front-image-id="formData?.FrontImageFileId"
        @click-edit="editImages"
        @click-delete="() => formData.Images = []"
      />

      <FormContentBlock
        v-for="(url, idx) in formData.Videos"
        :key="idx"
        blok-type="Video"
        :video-url="url"
        @click-delete="removeVideo(idx)"
      />

      <div class="constructor-adder">
        <p>Галерея мультимедия:</p>
        <BaseBtnNew
          name="Добавить фото"
          @clickBtn="onModalSwitch('Image', true)"
        >
          <addPhotoIcon/>
        </BaseBtnNew>
        <BaseBtnNew
          name="Добавить видео"
          @clickBtn="onModalSwitch('Video', true)"
        >
        <addVideoIcon/>
        </BaseBtnNew>
      </div>

      <div class="constructor-content">
        <div class="constructor-content__item content-item">
          <h2 class="content-item__title">Подробное описание (H2):</h2>
          <InputText
            v-model="formData.DescriptionHeader"
            type="text"
            placeholder="Описание"
            style="width: 100%; margin-bottom: 10px"
          />
          <!-- <h2 class="content-item__header">Описание</h2> -->
          <TextEditorBlock
            :editor-data="formData?.Description"
            @edit-data="onEditorDescription"
          />
        </div>
        <div class="content__item content-item">
          <h2 class="content-item__title">Технические характеристики (H2):</h2>
          <InputText
            v-model="formData.CharacteristicsHeader"
            type="text"
            placeholder="Характеристики"
            style="width: 100%; margin-bottom: 10px"
          />
          <!-- <h2 class="content-item__header">Характеристики</h2> -->
          <TextEditorBlock
            :editor-data="characteristicks"
            @edit-data="onEditCharacteristics"
          />
        </div>
      </div>

      <div class="tags">
        <h2 class="tags-title">Теги внутренней навигации:</h2>
        <TagBox
          header="Добавьте тег внутренней навигации"
          text-btn="Добавить новый тег"
          type-tag="inner"
          @openModal="showTags"
          :itemsArr="tags"
          :categoryId="activityId"
        />
        <div class="tags__btn">
          <BaseBtnNew
          name="Добавить тег"
          @clickBtn="showTags"
        >
          <addTagIcon/>
        </BaseBtnNew>

        <BaseBtnNew
            name="Очистить"
            :disabled="tags?.length === 0"
            @clickBtn="clearTags"
          >
          <clearIcon/>
          </BaseBtnNew>

        </div>
      </div>
    </FormConstructor>

    <TransitionGroup name="bounce">

      <BaseModalWindow
        v-show="modalState.Image"
        @close-modal="onModalSwitch"
        title="Добавление фото"
      >
        <ImageUploader
          ref="imageUploaderRef"
          main-photo
          @close-modal="onModalSwitch"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="modalState.Story"
        @close-modal="onModalSwitch"
        type-version="fromEditor"
        title="История изменений"
      >
        <StoryChangeModal
          type-version="fromEditor"
          :selected-default-id="formData.Id"
          :data-table="changeHistoryData"
          @select-version="onSelectHystoryItem"
          @close-modal="onModalSwitch"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-else-if="modalState.Video"
        @close-modal="onModalSwitch"
        title="Добавление видео"
      >
        <VideoUploader
          @close-modal="onModalSwitch"
          @save-video="addVideo"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="tagsModalVisible"
        @close-modal="closeTagsModal"
        title="Теги внутренней навигации"
      >
        <TagsModalNew :categoryId="activityId"/>
      </BaseModalWindow>

      <BaseModalWindow
        v-if="keywordsModalVisible"
        @close-modal="closeKeywordsModal"
        title="Поисковые ключевые слова"
      >
        <KeywordsModal :categoryId="activityId"/>
      </BaseModalWindow>

    </TransitionGroup>

  </LayoutDefault>
</template>

<script>
import { computed, ref, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { useRoute } from 'vue-router'
import { formaterDate } from '@/helpers/helpFunctions.js'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import FormConstructor from '@/components/blocks/FormConstructor.vue'
import TextEditorBlock from '@/components/elements/TextEditorBlock.vue'
import TagBox from '@/components/elements/TagBox.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import ImageUploader from '@/components/modals/ImageUploader.vue'
import StoryChangeModal from '@/components/modals/StoryChangeModal.vue'
import VideoUploader from '@/components/modals/VideoUploader.vue'
import TagsModalNew from '@/components/modals/TagsModalNew.vue'
import KeywordsModal from '@/components/modals/KeywordsModal.vue'
import FormContentBlock from '@/components/elements/FormContentBlock.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew'
import addPhotoIcon from '@/components/icons/addPhotoIcon'
import addVideoIcon from '@/components/icons/addVideoIcon'
import addTagIcon from '@/components/icons/addTagIcon'
import clearIcon from '@/components/icons/clearIcon'
import InputText from 'primevue/inputtext'

import { cutPolicies } from '@/helpers/policiesValidator.js'
import { useEditorSave } from '@/composables/useEditorSave.js'
import { sanitizeEditorHtml } from '@/helpers/unwrapEditorHtml.js'

export default {
  name: 'ProductsEditorView',
  components: {
    LayoutDefault,
    TagBox,
    FormConstructor,
    FormContentBlock,
    BaseBtnNew,
    addPhotoIcon,
    addVideoIcon,
    addTagIcon,
    clearIcon,
    TextEditorBlock,
    BaseModalWindow,
    ImageUploader,
    StoryChangeModal,
    VideoUploader,
    TagsModalNew,
    KeywordsModal,
    InputText
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    onBeforeMount(() => {
      // запрос на получение формы редактирования товара
      store.dispatch('setProductForm', `/api/Products/GetForm/${route.params.id}`)
    })

    const tags = computed(() => store.getters.getShowSelectedTags)

    watch(tags, (newValue) => {
      formData.value.InnerTags = newValue
    })

    const policies = computed(() => store.getters.getPolicies)

    const closeEditor = () => {
      // редирект назад на товары
      router.push('/products/0')
    }

    const characteristicks = computed(() => {
      // табличка характеристик по дефолту
      return store.getters.getFormData.Characteristics
    })

    const formData = computed(() => store.getters.getFormData)
    // объект формы товара (данные которые отобр. в конструкторе)

    const tagsModalVisible = computed(() => store.getters.getShowTagsEditor)

    const keywordsModalVisible = computed(() => store.getters.getShowKeywordsEditor)

    const imageUploaderRef = ref(null) // доступ к экземпляпляру редактора фото

    // Улучшенная функция для замены кавычек с сохранением атрибутов HTML
    const replaceQuotesInHTML = (html) => {
      if (!html || typeof html !== 'string') return html || ''

      // Временное хранение атрибутов HTML и других защищенных блоков
      const protectedBlocks = []
      let counter = 0

      // Шаг 1: Заменяем атрибуты HTML на плейсхолдеры
      const withProtectedBlocks = html.replace(
        /<\s*(\w+)(\s[^>]*)?>/g,
        (match, tagName, attributes) => {
          if (!attributes) return match

          // Защищаем атрибуты внутри тега
          const protectedAttributes = attributes.replace(
            /(\b\w+\s*=\s*)(["'`])([^\2]*?)\2/g,
            (attrMatch, attrName, quote, attrValue) => {
              const placeholder = `__PROTECTED_${counter}__`
              protectedBlocks.push({
                placeholder,
                value: attrMatch
              })
              counter++
              return placeholder
            }
          )

          return `<${tagName}${protectedAttributes}>`
        }
      )

      // Шаг 2: Заменяем кавычки в текстовом содержимом
      let result = withProtectedBlocks

      // Заменяем двойные кавычки, не входящие в состав HTML entities
      result = result.replace(/"([^"<>]+)"/g, (match, content) => {
        // Проверяем, что это не часть HTML entity
        if (/(?:^|\s|&|\W)"[^"]*"(?:\s|$|\W)/.test(match)) {
          return `«${content}»`
        }
        return match
      })

      // Заменяем HTML entities &quot;
      result = result.replace(/&quot;([^&]+)&quot;/g, '«$1»')

      // Заменяем одиночные кавычки в определенных контекстах
      result = result.replace(/(\s|^|\(|\[|{)['"]([^'"]+?)['"](\s|$|\)|\]|}|\.|,|\?|!)/g, '$1«$2»$3')

      // Шаг 3: Восстанавливаем защищенные блоки
      protectedBlocks.forEach(item => {
        result = result.replace(item.placeholder, item.value)
      })

      return result
    }

    // ----- редактирование в слоте (начало)
    const PRODUCT_HTML_FIELDS = ['Header', 'Synopsis', 'Description', 'Characteristics']

    const sanitizeAllProductHtmlFields = () => {
      PRODUCT_HTML_FIELDS.forEach((key) => {
        if (!formData.value[key]) return
        let html = formData.value[key]
        if (key === 'Description' || key === 'Characteristics') {
          html = replaceQuotesInHTML(html)
        }
        formData.value[key] = sanitizeEditorHtml(html)
      })
      formData.value.ContentBlocks?.forEach((block) => {
        if (block?.Type === 'HyperText' && block.Text) {
          block.Text = sanitizeEditorHtml(block.Text)
        }
      })
    }

    const onEditorDescription = (e) => {
      formData.value.Description = sanitizeEditorHtml(replaceQuotesInHTML(e))
    }

    const onEditCharacteristics = (e) => {
      formData.value.Characteristics = sanitizeEditorHtml(replaceQuotesInHTML(e))
    }

    const editImages = () => {
      // очищаем данные в компоненте
      imageUploaderRef.value.clearData()
      // добавляет в массив фоток фотографии из контент блока
      imageUploaderRef.value.fotosArr = formData.value.Images
      // делает выбранным изображением первое из контент блока
      imageUploaderRef.value.onSelectImage(formData.value.Images[0], 0)
      // включает спиннер на 2 секунды для плавного рендеринга
      imageUploaderRef.value.spinner = true

      setTimeout(() => {
        imageUploaderRef.value.spinner = false
      }, 2000)
      // открывает модалку
      modalState.value.Image = true
      store.commit('SetEditableImages', formData.value.Images)
    }
    // ----- редактирование в слоте (конец)

    // ------ методы вызываемые из конструктора (начало) -----
    const { isSaving, runSave } = useEditorSave()

    const onSaveProduct = () => {
      if (isSaving.value) return
      runSave(async () => {
        sanitizeAllProductHtmlFields()

        await store.dispatch('setSaveProduct', `/api/Products/PutForm/${formData.value.Id}`)
        await router.push(`/products/editor/${formData.value.Id}`)
        await store.dispatch('setProductForm', `/api/Products/GetForm/${formData.value.Id}`)
      })
    }

    const onTogglePublished = async (publish) => {
      // опубликовать или снять с публикации
      formData.value.Published = publish
      await store.dispatch('setToggleProductPublish', {
        url: `/api/Products/TooglePublish/${formData.value.Id}`,
        publish
      })
    }
    // ------ методы вызываемые из конструктора (конец) -----

    // ------ модалки (начало)------
    const modalState = ref({
      Image: false, // загрузчик фото
      Video: false, // загрузчик видео
      Story: false, // история изменений
      Tags: false // ключ слова и теги
    })

    const onModalSwitch = (modal, val = true) => {
      // modal -- это строка с именем модалки
      // val -- булевое значение
      if (modal === 'all') {
        for (const key in modalState.value) {
          modalState.value[key] = val
        }
      }
      // если вызываем модалку с imageUploader то очищаем предварительно его данные
      if (modal === 'Image' && val) {
        imageUploaderRef.value.clearData()
      }

      modalState.value[modal] = val
    }

    const addVideo = (link) => {
      formData.value.Videos.push(link)
      onModalSwitch('Video', false)
    }

    const removeVideo = (idx) => {
      formData.value.Videos.splice(idx, 1)
    }

    const changeHistoryData = computed(() => {
      // данные из ьаблички в модалке с историей версий
      return store.getters.getChangeHistoryData
    })

    const showStoryChangeModal = () => {
      // загружаем данные и показываем модалку истории версий
      store.dispatch('setChangeHistory', `/api/Products/GetChangeHistory/${formData.value.Id}`)

      onModalSwitch('Story', true)
    }

    const onSelectHystoryItem = (selectedId) => {
      // загружаем версию в первую колонку и открываем страницу истории изменений
      store.dispatch('setFirstColData', `/api/Products/GetForm/${selectedId}`)
      router.push(`/products/version/${formData.value.Id}`)
    }
    // ------ модалки (конец)------

    const showTags = () => {
      store.dispatch('setTagsData')
      store.commit('SetShowTagsEditor', true)
    }

    const showKeywords = () => {
      store.dispatch('setKeywordsData')
      store.commit('SetShowKeywordsEditor', true)
    }

    const closeTagsModal = () => {
      store.commit('SetShowTagsEditor', false)
      store.dispatch('setClearCacheInnerTag')
    }

    const closeKeywordsModal = () => {
      store.commit('SetShowKeywordsEditor', false)
      store.dispatch('setClearCacheInnerKeywords')
    }

    const activityId = 3

    const canSave = ref(false)

    const updateFormValidity = (data) => {
      canSave.value = data.canSave
    }

    const canPublish = ref(false)

    const updatePublishStatus = (data) => {
      canPublish.value = data.canPublish
    }
    const clearTags = () => {
      formData.value.InnerTags = []
      store.dispatch('setClearAllTagProducts')
    }

    return {
      closeEditor,
      clearTags,
      formaterDate,
      formData,
      policies,
      cutPolicies,
      characteristicks,
      onEditCharacteristics,
      onEditorDescription,
      editImages,
      onSaveProduct,
      onTogglePublished,
      modalState,
      onModalSwitch,
      imageUploaderRef,
      addVideo,
      removeVideo,
      changeHistoryData,
      showStoryChangeModal,
      onSelectHystoryItem,
      isSaving,
      tagsModalVisible,
      keywordsModalVisible,
      showTags,
      showKeywords,
      closeTagsModal,
      closeKeywordsModal,
      activityId,
      tags,
      updateFormValidity,
      canSave,
      updatePublishStatus,
      canPublish
    }
  }
}
</script>

<style lang="scss" scoped>

.constructor-content {

  &__item, .content-item {
    padding: 10px 0;

    &__title {
      font-weight: 500;
      font-size: 18px;
      text-align: left;
      margin-bottom: 8px;
    }

    &__header {
      text-align: left;
      font-weight: 500;
      font-size: 18px;
      line-height: 1.8;
    }
  }
}
.constructor-adder {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 24px;
}
.tags {
  &-title {
    font-weight: 500;
    font-size: 18px;
    text-align: left;
    margin-bottom: 8px;
  }

  &__btn {
    margin-top: 8px;
    display: flex;
    gap: 12px;
  }
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

</style>
